// import React, { useState } from 'react';
// import { Helmet } from 'react-helmet';
// import { Link } from 'react-router-dom';
// import FAQSchema from '../../FAQSchema';
// import AdBanner from '../AdPage/AdBanner';

// const SalaryCalculator = () => {
//   const [ctc, setCtc] = useState(600000);
//   const [bonusType, setBonusType] = useState('amount');
//   const [bonus, setBonus] = useState(15);
//   const [professionalTax, setProfessionalTax] = useState(200);
//   const [employerPf, setEmployerPf] = useState(1800);
//   const [employeePf, setEmployeePf] = useState(1800);
//   const [additionalDeduction1, setAdditionalDeduction1] = useState(0);
//   const [additionalDeduction2, setAdditionalDeduction2] = useState(0);

//   const calculateTotalDeductions = () => {
//     return professionalTax + employerPf + employeePf + additionalDeduction1 + additionalDeduction2;
//   };

//   const calculateTakeHomeSalary = () => {
//     const monthlyCtc = ctc / 12;
//     const bonusAmount = bonusType === 'amount' ? bonus : (bonus / 100) * ctc / 12;
//     const totalDeductions = calculateTotalDeductions();
//     return monthlyCtc + bonusAmount - totalDeductions;
//   };

//   const monthlyTakeHome = calculateTakeHomeSalary();
//   const annualTakeHome = monthlyTakeHome * 12;
//   const totalDeductions = calculateTotalDeductions();
//   const annualDeductions = totalDeductions * 12;
// function Icon({ id, open }) {
//       return (
//           <svg
//               xmlns="http://www.w3.org/2000/svg"
//               fill="none"
//               viewBox="0 0 24 24"
//               strokeWidth={2}
//               stroke="currentColor"
//               className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
//           >
//               <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
//           </svg>
//       );
//     }
    
    
//       const [activeIndex, setActiveIndex] = useState(0);
    
       
//       const faqs = [
        
//           {
//             "question": "What is a Salary?",
//             "answer": "A salary is the fixed, regular payment you receive from your employer for your work, typically on a monthly basis. It includes various components like basic pay, allowances, and benefits as defined in your employment contract."
//           },
//           {
//             "question": "What is a Salary Calculator and how does it help?",
//             "answer": "A salary calculator is a digital tool that helps you estimate your take-home salary by factoring in your gross salary, bonuses, taxes, and deductions such as provident fund (PF) and professional tax."
//           },
//           {
//             "question": "What is the difference between Gross Salary and Net Salary?",
//             "answer": "Gross salary is your total earnings before deductions. Net salary, also known as take-home pay, is what you receive after all deductions like taxes and EPF are subtracted."
//           },
//           {
//             "question": "What is CTC and how is it different from Take-Home Salary?",
//             "answer": "CTC (Cost to Company) is the total amount a company spends on an employee, including basic pay, allowances, benefits, and bonuses. Take-home salary is what the employee actually receives in hand after deductions."
//           },
//           {
//             "question": "What components are included in the salary structure?",
//             "answer": "Common components include Basic Salary, House Rent Allowance (HRA), Leave Travel Allowance (LTA), Special Allowance, Bonus, Employee Provident Fund (EPF), and Professional Tax."
//           },
//           {
//             "question": "How does TheFinMaster Salary Calculator work?",
//             "answer": "Simply input your CTC, bonus, and any applicable deductions into the calculator. The tool automatically computes your gross and net salary by accounting for factors like PF, professional tax, and insurance."
//           },
//           {
//             "question": "Can the calculator show monthly and annual salary breakdowns?",
//             "answer": "Yes, TheFinMaster Salary Calculator provides a clear breakdown of both monthly and annual salaries, including deductions and net income."
//           },
//           {
//             "question": "Does the tool consider Employee Provident Fund (EPF) deductions?",
//             "answer": "Absolutely. It factors in both your and your employer’s 12% EPF contribution based on your basic salary (capped at Rs 15,000 per month), ensuring an accurate net salary estimate."
//           },
//           {
//             "question": "How accurate is the salary estimate provided by the calculator?",
//             "answer": "While TheFinMaster calculator gives close estimates based on standard deduction norms, the exact take-home salary may vary depending on your company’s specific salary structure and benefits."
//           },
//           {
//             "question": "Can I use the calculator if I receive performance bonuses?",
//             "answer": "Yes. You can add bonuses as separate components while calculating. The calculator deducts it from your CTC to compute your gross and net salary more precisely."
//           },
//           {
//             "question": "What is Professional Tax and how does it impact salary?",
//             "answer": "Professional Tax is a state-imposed tax on salaried individuals, usually around Rs 2,400 annually. It’s included in the salary calculator to reflect its impact on your net pay."
//           },
//           {
//             "question": "What other deductions are considered by the salary calculator?",
//             "answer": "In addition to EPF and Professional Tax, the calculator also considers Employee Insurance and other standard deductions applicable in India."
//           },
//           {
//             "question": "Why should I use a salary calculator before accepting a job offer?",
//             "answer": "It helps you estimate your actual in-hand salary, giving you clarity before negotiating offers. This ensures informed decision-making and financial planning."
//           },
//           {
//             "question": "How does a salary calculator support financial planning?",
//             "answer": "By showing a clear breakdown of your income and deductions, it helps you plan savings, investments, and monthly expenses more effectively."
//           },
//           {
//             "question": "Is TheFinMaster Salary Calculator free to use?",
//             "answer": "Yes. TheFinMaster Salary Calculator is a free tool designed to help you understand your income better and make smarter financial decisions."
//           }
//         ];
//       const toggleAccordion = (index) => {
//         if (activeIndex === index) {
//             // If the clicked question is already expanded, collapse it
//             setActiveIndex(null);
//         } else {
//             // If the clicked question is not expanded, expand it
//             setActiveIndex(index);
//         };
//       }
//   return (
//     <>
//      <Helmet>
//          <title>Salary Calculator – In-Hand Salary & Tax Deductions</title>
//         <meta  name='description' content='Calculate your in-hand salary after deductions with our detailed salary calculator. Know your monthly take-home pay.'/>
//         <meta name='keywords' content='salary income tax calculator, online income tax calculator, ctc calculator, calculate salary hike, calculate tds on salary' />
//         <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/salary-calculator" />
//         <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
//         <meta name="robots" content="max-video-preview:-1" />
//       </Helmet>
//       <FAQSchema faqs={faqs} />
//       {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
//       <ol className="list-none p-0 inline-flex">
//         <li className="flex items-center">
//           <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
//           <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
//             <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
//           </svg>
//         </li>
//         <li className="flex items-center">
//           <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
//           <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
//             <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
//           </svg>
//         </li>
//           <li className="flex items-center">
//           <span className="text-gray-500 ">Salary Calculator</span>
//         </li> 
      
//       </ol>
//     </nav> */}
//         <div className="w-full flex justify-center items-center px-4 mt-20">
//       <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
//       <AdBanner displayOrder="1" />
//       </div>
//     </div>
//       <div className='py-3'>
//         <div className="container mx-auto p-2 max-w-7xl flex flex-col md:flex-row items-start gap-4">
          
//           <div className="w-full md:w-2/3 p-4 bg-white shadow-xl rounded-md">
//             <h2 className="text-2xl font-bold mb-4">Salary Calculator</h2>
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <div>
//                 <label className="block mb-2 font-semibold">Cost to Company (CTC)</label>
//                 <input
//                   type="number"
//                   value={ctc}
//                   onChange={(e) => setCtc(Number(e.target.value))}
//                   className="w-full p-2 border rounded"
//                 />
//               </div>
//               <div>
//                 <label className="block mb-2 font-semibold">Bonus Included in CTC</label>
//                 <div className="flex">
//                   <select
//                     value={bonusType}
//                     onChange={(e) => setBonusType(e.target.value)}
//                     className="p-2 border rounded-l"
//                   >
//                     <option value="amount">Amount</option>
//                     <option value="percentage">Percentage</option>
//                   </select>
//                   <input
//                     type="number"
//                     value={bonus}
//                     onChange={(e) => setBonus(Number(e.target.value))}
//                     className="w-full p-2 border rounded-r"
//                   />
//                 </div>
//               </div>
//               <div>
//                 <label className="block mb-2 font-semibold">Monthly Professional Tax</label>
//                 <input
//                   type="number"
//                   value={professionalTax}
//                   onChange={(e) => setProfessionalTax(Number(e.target.value))}
//                   className="w-full p-2 border rounded"
//                 />
//               </div>
//               <div>
//                 <label className="block mb-2 font-semibold">Monthly Employer PF</label>
//                 <input
//                   type="number"
//                   value={employerPf}
//                   onChange={(e) => setEmployerPf(Number(e.target.value))}
//                   className="w-full p-2 border rounded"
//                 />
//               </div>
//               <div>
//                 <label className="block mb-2 font-semibold">Monthly Employee PF</label>
//                 <input
//                   type="number"
//                   value={employeePf}
//                   onChange={(e) => setEmployeePf(Number(e.target.value))}
//                   className="w-full p-2 border rounded"
//                 />
//               </div>
//               <div>
//                 <label className="block mb-2 font-semibold">Monthly Additional Deduction (Optional)</label>
//                 <input
//                   type="number"
//                   value={additionalDeduction1}
//                   onChange={(e) => setAdditionalDeduction1(Number(e.target.value))}
//                   className="w-full p-2 border rounded"
//                 />
//               </div>
//               <div>
//                 <label className="block mb-2 font-semibold">Monthly Additional Deduction (Optional)</label>
//                 <input
//                   type="number"
//                   value={additionalDeduction2}
//                   onChange={(e) => setAdditionalDeduction2(Number(e.target.value))}
//                   className="w-full p-2 border rounded"
//                 />
//               </div>
//             </div>
//             <div className="mt-6">
//               <div className="flex justify-between mb-2">
//                 <span>Total Monthly Deductions</span>
//                 <span>₹{totalDeductions}</span>
//               </div>
//               <div className="flex justify-between mb-2">
//                 <span>Total Annual Deductions</span>
//                 <span>₹{annualDeductions}</span>
//               </div>
//               <div className="flex justify-between mb-2">
//                 <span>Take Home Monthly Salary</span>
//                 <span>₹{monthlyTakeHome.toFixed(2)}</span>
//               </div>
//               <div className="flex justify-between mb-2">
//                 <span>Take Home Annual Salary</span>
//                 <span>₹{annualTakeHome.toFixed(2)}</span>
//               </div>
//             </div>
//           </div>
//           <div className="w-full md:w-1/3 p-2 flex justify-center items-center shadow-xl rounded-md ">
//             <div className="w-full max-w-xs text-center">
//               <div className="mb-4">
//                 <img src="https://www.shutterstock.com/image-illustration/credit-cards-online-shopping-banner-260nw-355524626.jpg" alt="Banner" className="w-full rounded" />
//               </div>
//               <div>
//                 <h2 className="text-lg font-bold mb-2">Invest the way you want</h2>
//                 <p className="text-gray-600 mb-4">Join millions of Indians who trust and love TheFinMaster</p>
//                 <button className="bg-green-500 text-white py-2 px-4 rounded my-3">EXPLORE PRODUCTS</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
     import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

const SalaryCalculator = () => {
  const [ctc, setCtc] = useState(600000);
  const [bonusType, setBonusType] = useState('amount');
  const [bonus, setBonus] = useState(15);
  const [professionalTax, setProfessionalTax] = useState(200);
  const [employerPf, setEmployerPf] = useState(1800);
  const [employeePf, setEmployeePf] = useState(1800);
  const [additionalDeduction1, setAdditionalDeduction1] = useState(0);
  const [additionalDeduction2, setAdditionalDeduction2] = useState(0);

  // State for calculated results
  const [calculatedResults, setCalculatedResults] = useState({
    totalDeductions: 0,
    annualDeductions: 0,
    monthlyTakeHome: 0,
    annualTakeHome: 0
  });

  const calculateTotalDeductions = () => {
    return professionalTax + employerPf + employeePf + additionalDeduction1 + additionalDeduction2;
  };

  const calculateTakeHomeSalary = () => {
    const monthlyCtc = ctc / 12;
    const bonusAmount = bonusType === 'amount' ? bonus : (bonus / 100) * ctc / 12;
    const totalDeductions = calculateTotalDeductions();
    return monthlyCtc + bonusAmount - totalDeductions;
  };

  const handleCalculate = () => {
    const totalDeductions = calculateTotalDeductions();
    const monthlyTakeHome = calculateTakeHomeSalary();
    const annualTakeHome = monthlyTakeHome * 12;
    const annualDeductions = totalDeductions * 12;

    setCalculatedResults({
      totalDeductions,
      annualDeductions,
      monthlyTakeHome,
      annualTakeHome
    });
  };

  function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  const [activeIndex, setActiveIndex] = useState(0);
  
  const faqs = [
    {
      "question": "What is a Salary?",
      "answer": "A salary is the fixed, regular payment you receive from your employer for your work, typically on a monthly basis. It includes various components like basic pay, allowances, and benefits as defined in your employment contract."
    },
    {
      "question": "What is a Salary Calculator and how does it help?",
      "answer": "A salary calculator is a digital tool that helps you estimate your take-home salary by factoring in your gross salary, bonuses, taxes, and deductions such as provident fund (PF) and professional tax."
    },
    {
      "question": "What is the difference between Gross Salary and Net Salary?",
      "answer": "Gross salary is your total earnings before deductions. Net salary, also known as take-home pay, is what you receive after all deductions like taxes and EPF are subtracted."
    },
    {
      "question": "What is CTC and how is it different from Take-Home Salary?",
      "answer": "CTC (Cost to Company) is the total amount a company spends on an employee, including basic pay, allowances, benefits, and bonuses. Take-home salary is what the employee actually receives in hand after deductions."
    },
    {
      "question": "What components are included in the salary structure?",
      "answer": "Common components include Basic Salary, House Rent Allowance (HRA), Leave Travel Allowance (LTA), Special Allowance, Bonus, Employee Provident Fund (EPF), and Professional Tax."
    },
    {
      "question": "How does TheFinMaster Salary Calculator work?",
      "answer": "Simply input your CTC, bonus, and any applicable deductions into the calculator. The tool automatically computes your gross and net salary by accounting for factors like PF, professional tax, and insurance."
    },
    {
      "question": "Can the calculator show monthly and annual salary breakdowns?",
      "answer": "Yes, TheFinMaster Salary Calculator provides a clear breakdown of both monthly and annual salaries, including deductions and net income."
    },
    {
      "question": "Does the tool consider Employee Provident Fund (EPF) deductions?",
      "answer": "Absolutely. It factors in both your and your employer's 12% EPF contribution based on your basic salary (capped at Rs 15,000 per month), ensuring an accurate net salary estimate."
    },
    {
      "question": "How accurate is the salary estimate provided by the calculator?",
      "answer": "While TheFinMaster calculator gives close estimates based on standard deduction norms, the exact take-home salary may vary depending on your company's specific salary structure and benefits."
    },
    {
      "question": "Can I use the calculator if I receive performance bonuses?",
      "answer": "Yes. You can add bonuses as separate components while calculating. The calculator deducts it from your CTC to compute your gross and net salary more precisely."
    },
    {
      "question": "What is Professional Tax and how does it impact salary?",
      "answer": "Professional Tax is a state-imposed tax on salaried individuals, usually around Rs 2,400 annually. It's included in the salary calculator to reflect its impact on your net pay."
    },
    {
      "question": "What other deductions are considered by the salary calculator?",
      "answer": "In addition to EPF and Professional Tax, the calculator also considers Employee Insurance and other standard deductions applicable in India."
    },
    {
      "question": "Why should I use a salary calculator before accepting a job offer?",
      "answer": "It helps you estimate your actual in-hand salary, giving you clarity before negotiating offers. This ensures informed decision-making and financial planning."
    },
    {
      "question": "How does a salary calculator support financial planning?",
      "answer": "By showing a clear breakdown of your income and deductions, it helps you plan savings, investments, and monthly expenses more effectively."
    },
    {
      "question": "Is TheFinMaster Salary Calculator free to use?",
      "answer": "Yes. TheFinMaster Salary Calculator is a free tool designed to help you understand your income better and make smarter financial decisions."
    }
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
        // If the clicked question is already expanded, collapse it
        setActiveIndex(null);
    } else {
        // If the clicked question is not expanded, expand it
        setActiveIndex(index);
    }
  };

  return (
    <>
     <Helmet>
         <title>Salary Calculator – In-Hand Salary & Tax Deductions</title>
        <meta  name='description' content='Calculate your in-hand salary after deductions with our detailed salary calculator. Know your monthly take-home pay.'/>
        <meta name='keywords' content='salary income tax calculator, online income tax calculator, ctc calculator, calculate salary hike, calculate tds on salary' />
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/salary-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />

        <div className="w-full flex justify-center items-center px-4 mt-20">
          <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
            <AdBanner displayOrder="1" />
          </div>
        </div>

      <div className='py-3'>
        <div className="container mx-auto p-2 max-w-7xl flex flex-col md:flex-row items-start gap-4">
          
          <div className="w-full md:w-2/3 p-4 bg-white shadow-xl rounded-md">
            <h1 className="text-2xl font-bold mb-4">Salary Calculator</h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block mb-2 font-semibold">Cost to Company (CTC)</label>
                <input
                  type="number"
                  value={ctc}
                  onChange={(e) => setCtc(Number(e.target.value))}
                  className="w-full p-2 border rounded"
                />
              </div>
              <div>
                <label className="block mb-2 font-semibold">Bonus Included in CTC</label>
                <div className="flex">
                  <select
                    value={bonusType}
                    onChange={(e) => setBonusType(e.target.value)}
                    className="p-2 border rounded-l"
                  >
                    <option value="amount">Amount</option>
                    <option value="percentage">Percentage</option>
                  </select>
                  <input
                    type="number"
                    value={bonus}
                    onChange={(e) => setBonus(Number(e.target.value))}
                    className="w-full p-2 border rounded-r"
                  />
                </div>
              </div>
              <div>
                <label className="block mb-2 font-semibold">Monthly Professional Tax</label>
                <input
                  type="number"
                  value={professionalTax}
                  onChange={(e) => setProfessionalTax(Number(e.target.value))}
                  className="w-full p-2 border rounded"
                />
              </div>
              <div>
                <label className="block mb-2 font-semibold">Monthly Employer PF</label>
                <input
                  type="number"
                  value={employerPf}
                  onChange={(e) => setEmployerPf(Number(e.target.value))}
                  className="w-full p-2 border rounded"
                />
              </div>
              <div>
                <label className="block mb-2 font-semibold">Monthly Employee PF</label>
                <input
                  type="number"
                  value={employeePf}
                  onChange={(e) => setEmployeePf(Number(e.target.value))}
                  className="w-full p-2 border rounded"
                />
              </div>
              <div>
                <label className="block mb-2 font-semibold">Monthly Additional Deduction (Optional)</label>
                <input
                  type="number"
                  value={additionalDeduction1}
                  onChange={(e) => setAdditionalDeduction1(Number(e.target.value))}
                  className="w-full p-2 border rounded"
                />
              </div>
              <div>
                <label className="block mb-2 font-semibold">Monthly Additional Deduction (Optional)</label>
                <input
                  type="number"
                  value={additionalDeduction2}
                  onChange={(e) => setAdditionalDeduction2(Number(e.target.value))}
                  className="w-full p-2 border rounded"
                />
              </div>
            </div>
            
            {/* Calculate Button */}
            <div className="mt-6 mb-4">
              <button 
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
                onClick={handleCalculate}
              >
                Calculate
              </button>
            </div>
            
            <div className="mt-6">
              <div className="flex justify-between mb-2">
                <span>Total Monthly Deductions</span>
                <span>₹{calculatedResults.totalDeductions}</span>
              </div>
              <div className="flex justify-between mb-2">
                <span>Total Annual Deductions</span>
                <span>₹{calculatedResults.annualDeductions}</span>
              </div>
              <div className="flex justify-between mb-2">
                <span>Take Home Monthly Salary</span>
                <span>₹{calculatedResults.monthlyTakeHome.toFixed(2)}</span>
              </div>
              <div className="flex justify-between mb-2">
                <span>Take Home Annual Salary</span>
                <span>₹{calculatedResults.annualTakeHome.toFixed(2)}</span>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/3 p-2 flex justify-center items-center shadow-xl rounded-md ">
            <div className="w-full max-w-xs text-center">
              <div className="mb-4">
                <img src="https://www.shutterstock.com/image-illustration/credit-cards-online-shopping-banner-260nw-355524626.jpg" alt="Banner" className="w-full rounded" />
              </div>
              <div>
                <h2 className="text-lg font-bold mb-2">Invest the way you want</h2>
                <p className="text-gray-600 mb-4">Join millions of Indians who trust and love TheFinMaster</p>
                <button className="bg-green-500 text-white py-2 px-4 rounded my-3">EXPLORE PRODUCTS</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div className="flex flex-wrap px-6 py-6" >
     <div className="w-full md:w-2/3 p-4">
     <div className="container mx-auto py-4">
       <h2 className="text-xl font-medium  bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">What is a Salary?

</h2>
          {/* <h2 className="text-xl font-medium  bg-blue-100 border-l-4 border-blue-600 pl-4 py-2 ">What is a Salary?</h2> */}
            <p className="text-lg font-normal mt-2 text-gray-700 ">Your salary is the regular payment you receive from your employer for the work you perform. The details of your salary and any additional benefits are typically outlined in your employment contract. This guide unpacks the concept of salary, its components, and how salary calculators help you understand your net pay. 
            </p>
           
          </div>
          <div className="container mx-auto  py-4">
          <h2 className="text-xl font-medium  bg-blue-100 border-l-4 border-blue-600 pl-4 py-2 ">What is a Salary Calculator? </h2>
            <p className="text-lg font-normal mt-2 text-gray-700 ">A salary calculator is a user-friendly tool that helps you estimate your take-home salary, both annually and monthly. It factors in deductions from your gross salary (Cost To Company or CTC) to arrive at your net pay. 
            </p>
           
          </div>
<div className="container mx-auto  py-4">
            <h2 className="text-xl font-medium  bg-blue-100 border-l-4 border-blue-600 pl-4 py-2 ">What are the basic components of the Salary Structure?
</h2>
           
            
            <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2"> {/* Added pl-6 for left padding */}
           <span className="absolute left-0 top-0  text-blue-600">&#8226;</span> {/* Adjusted mt and added margin */}
           <span className='font-bold'>     Basic Salary: </span> This forms a significant portion (around 40-50%) of your CTC and is determined by your experience, qualifications, skills, and knowledge. It's a fixed component. 

         </p>
         <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 "> {/* Added pl-6 for left padding */}
           <span className="absolute left-0 top-0  text-blue-600">&#8226;</span> {/* Adjusted mt and added margin */}
           <span className='font-bold'>  House Rent Allowance (HRA):</span>    This component helps offset your rental expenses if you live in rented accommodation. A portion of your HRA may be exempt from taxes under specific tax regulations. 

           </p>
           <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 "> {/* Added pl-6 for left padding */}
           <span className="absolute left-0 top-0  text-blue-600">&#8226;</span> {/* Adjusted mt and added margin */}
           <span className='font-bold'>  Leave Travel Allowance (LTA):</span>    Employers may offer LTA to cover your travel expenses for vacations. Submitting proof of travel is usually required to claim this allowance. Professional Tax: This state-levied tax is applicable to your employment income. There's a yearly maximum limit on the amount a state can charge as professional tax. Special Allowance: Some employers offer special allowances, which are fully taxable. 

           </p>
      
<p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 "> {/* Added pl-6 for left padding */}
           <span className="absolute left-0 top-0  text-blue-600">&#8226;</span> {/* Adjusted mt and added margin */}
           <span className='font-bold'> Employee Provident Fund (EPF) Contribution:</span>     Both you and your employer contribute 12% of your basic salary towards the EPF scheme each month. Your contribution qualifies for tax deductions. 

           </p>
           <p className="text-lg font-normal  text-gray-600  "><span className='text-gray-800 text-xl font-bold mt-2'>Bonus :</span> Performance-based incentives provided by your employer are considered bonuses. 
</p>
          </div>

          <div className="container mx-auto  py-4">
          <h2 className="text-xl font-medium  bg-blue-100 border-l-4 border-blue-600 pl-4 py-2 ">How Do Salary Calculators Work? </h2>
            <p className="text-lg font-normal mt-2 text-gray-700 ">To calculate your take-home salary, you'll need to input details like your CTC, bonus, deductions (professional tax, PF, etc.) into the calculator. 
            </p>
            <p className="text-lg font-normal mt-2 text-gray-700 "><span className='text-gray-800 text-xl font-bold'>Example:</span>   Let's say your CTC is Rs 5 lakh and you receive a bonus of Rs 50,000. Your gross salary would be Rs 5,00,000 - Rs 50,000 = Rs 4,50,000 (as the bonus is deducted from CTC). 


            </p>
            <p className="text-lg font-normal mt-2 text-gray-700 ">Gross Salary (Rs 4,50,000) - Deductions = Take-Home Salary </p>
                        <p className="text-lg font-normal mt-2 text-gray-700 ">Gross Salary (Rs 4,50,000) - Deductions = Take-Home Salary </p>

          </div>
          <div className="container mx-auto  py-4">
          <h2 className="text-xl font-medium  bg-blue-100 border-l-4 border-blue-600 pl-4 py-2 ">Here's a breakdown of possible deductions: 
 </h2>
            <p className="text-lg font-normal mt-2 text-gray-700 ">Professional Tax: Rs 2,400 per year (example)
            </p>
           
            <p className="text-lg font-normal mt-2 text-gray-700 ">Employee Provident Fund (EPF) Contribution (Employee + Employer): Rs 21,600 per year each (calculated on a maximum basic salary of Rs 15,000 per month) </p>
                        <p className="text-lg font-normal mt-2 text-gray-700 ">Employee Insurance: Rs 2,000 per year (assumed)  </p>
                        <p className="text-lg font-normal mt-2 text-gray-700 ">Total Deductions = Rs 2,400 + Rs 21,600 (Employee) + Rs 21,600 (Employer) + Rs 2,000 = Rs 47,600 </p>
                        <p className="text-lg font-normal mt-2 text-gray-700 ">Take-Home Salary = Rs 4,50,000 - Rs 47,600 = Rs 4,02,400 
  </p>


          </div>
          
          
          <div className="container mx-auto  py-4">
          <h2 className="text-xl font-medium  bg-blue-100 border-l-4 border-blue-600 pl-4 py-2 ">What is an Inflation Calculator?
</h2>
            <p className="text-lg font-bold mt-2 text-gray-700 ">Here's what they can do: </p>
            <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2"> {/* Added pl-6 for left padding */}
           <span className="absolute left-0 top-0  text-blue-600">&#8226;</span> {/* Adjusted mt and added margin */}
           <span className='font-bold'>    Show purchasing power: </span> Imagine you have $100 today. An inflation calculator can estimate how much that $100 will be worth in 10 years, considering inflation.

         </p><p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2"> {/* Added pl-6 for left padding */}
           <span className="absolute left-0 top-0  text-blue-600">&#8226;</span> {/* Adjusted mt and added margin */}
           <span className='font-bold'>   Investment comparison: </span> Thinking about investing? Inflation calculators can also factor in potential investment returns. This helps you compare how much your money would grow with inflation alone versus with an investment strategy.
         </p>
     
<p className="text-lg font-normal mt-2 text-gray-700 ">Basically, inflation calculators are like time machines for your money! They help you see how inflation and potential investments might impact your purchasing power down the road.
</p>
            </div>
  <div className="w-full flex justify-center items-center my-6 px-4">
                <div className="w-full max-w-[984px]">
      
           
              <AdBanner displayOrder="3" />
              </div>
               
              </div>
            <div className="container mx-auto  py-4">
          <h2 className="text-xl font-medium  bg-blue-100 border-l-4 border-blue-600 pl-4 py-2 ">Benefits of Using a Salary Calculator in India 

</h2>
          
            <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2"> {/* Added pl-6 for left padding */}
           <span className="absolute left-0 top-0  text-blue-600">&#8226;</span> {/* Adjusted mt and added margin */}
           <span className='font-bold'>   Quick Results:  </span>  Salary calculators like TheFinMaster's can provide your take-home salary estimate within seconds. 

         </p>
         <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2"> {/* Added pl-6 for left padding */}
           <span className="absolute left-0 top-0  text-blue-600">&#8226;</span> {/* Adjusted mt and added margin */}
           <span className='font-bold'> Impact Analysis:  </span>  They help you understand how changes like bonuses or deductions affect your salary structure. 

         </p>
         <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2"> {/* Added pl-6 for left padding */}
           <span className="absolute left-0 top-0  text-blue-600">&#8226;</span> {/* Adjusted mt and added margin */}
           <span className='font-bold'>    Clear Breakdown:  </span> Salary calculators offer a clear picture of your gross salary and how various components and deductions contribute to your net pay. 

         </p>
         <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg relative pl-6 mt-2"> {/* Added pl-6 for left padding */}
           <span className="absolute left-0 top-0  text-blue-600">&#8226;</span> {/* Adjusted mt and added margin */}
           <span className='font-bold'>    Informed Decisions:   </span> Tools like TheFinMaster's CTC calculator can help you estimate your monthly and annual deductions, including EPF contributions by you and your employer.

         </p>
         
     

            </div>
           

     </div>


     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>

                           {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
    </>
  );
};

export default SalaryCalculator;
